module.exports = __webpack_public_path__ + "static/img/error.4bf0f0c.png";